import React from "react";
import SpecialForm from "./SpecialForm";

const AddSpecial = () => {
  return <SpecialForm title="Adicionar Especial" special={false} />;
};

export default AddSpecial;